import React from 'react';
import styles from './Card.module.scss';
import Button from '../forms/button/Button';
import { useBrandingContext } from 'app-context/BrandingsContext';

const Card = ({ title, actions, body, style }) => {
  const { brandingData } = useBrandingContext();

  return (
    <div
      className={styles['card-container']}
      style={{
        border:
          '#fff' === brandingData?.page_BackgroundColor
            ? '1px solid #d1d1d1'
            : '',
        ...style,
      }}
    >
      {title && (
        <>
          <div className={styles['card-header']}>
            <span className={styles['card-title']}>{title}</span>
            {actions ? (
              <div className={styles['buttons-container']}>
                {actions.map((icon, index) => {
                  return (
                    <Button
                      label={icon.label}
                      variant={icon.variant}
                      onClick={() => {
                        icon.func();
                      }}
                      opicBackground
                      key={index}
                      buttonType="button"
                    />
                  );
                })}
              </div>
            ) : null}
          </div>
          <hr className={styles['separator']} />
        </>
      )}
      <div className={styles['card-body']}>{body}</div>
    </div>
  );
};

export default Card;
